import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import './ELSACourse.css';
import NavCourse from 'components/NavCourse/NavCourse';

const ELSACourse: React.FC = () => {
  return (
    <Layout style={{ backgroundColor: '#ffffff' }}>
      <NavCourse />
      <article className="site-layout__nav">
        <Outlet />
      </article>
    </Layout>
  );
};

export default ELSACourse;
